export default __webpack_public_path__ + "static/media/upload.eff882ec.svg";